module.exports = __webpack_public_path__ + "img/Room5_005.e197b4b5.svg";